import { TypedLazyQueryTrigger } from '@reduxjs/toolkit/dist/query/react';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';
import { isDefined } from 'class-validator';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { CategoryObject } from 'src/app/components/TableComponent/MediaInsightTableComponent/media-insight-table.config';
import { timeHelper } from 'src/app/helpers';
import { getEnumKeyByValue, getEnumSelectOptions } from 'src/app/helpers/enum.helper';
import { objectDeepCompare } from 'src/app/helpers/object.helper';
import { InterestPropertiesType } from 'src/app/pages/InterestsPage/interests-page.config';
import { NSearchReport } from 'src/app/redux/nSearch/nSearch-slice-type';
import { SeedsResultType } from 'src/app/redux/seeds/seeds-slice.type';
import { InterestsWithNames } from 'src/app/services/interest/interest.service.type';
import {
  BlockResultType,
  ChartResultType,
  NSearchResultType,
  NSearchTagType,
} from 'src/app/services/surfer-service/surfer.service.type';
import { sensorCategoriesOfTypes } from 'src/configs/interests.config';
import { MEDIA_TYPE_WHITELIST, SENSOR_CATEGORY_TYPE_WHITELIST, SENSOR_TYPE_WHITELIST } from 'src/configs/system.config';
import { InterestClassType, InterestsTypes } from 'src/enums/interests.enum';
import { SensorCategoryType, SensorType } from 'src/enums/nginr-type.enum';
import { MediaType } from 'src/enums/surfer.enums';
import { LookupDataType, NSearchType } from 'src/types/query.type';
import { RoutesType } from 'src/types/routes.type';
import { SensorIdentified } from 'src/types/sensor.type';
import { MediaColumnDataType, NSearchReportColumnType } from 'src/types/table.type';

export const defaultCategories: NSearchType['categories'] = {
  company: [],
  industry: [],
  location: [],
  topic: [],
  communication: [],
  functionalArea: [],
  person: [],
  vehicle: [],
  object: [],
  incident: [],
  agent: [],
  relation: [],
  transaction: [],
};

export const defaultNSearchQuery: NSearchType = {
  categories: { ...defaultCategories },
  enterpriseId: '',
  systemTime: null,
  coordinates: [],
  endFusionDate: null,
  startFusionDate: null,
  mediaTypes: [],
  startTime: null,
  endTime: null,
  sensors: [],
  sensorCategoryTypes: [],
  sensorTypes: [],
};
// NSearch filters object
export const INTERESTS_FILTER_DATA: () => InterestFilterType = () => ({
  interestFilters: [
    {
      title: 'Company',
      interestType: InterestsTypes.Enterprise,

      options: [],
      classTypes: [InterestClassType.Identified],
    },
    {
      title: 'Location',
      interestType: InterestsTypes.Location,

      options: [],
      route: '/Location',
      classTypes: [InterestClassType.Identified, InterestClassType.Recognized],
    },
    {
      title: 'Industry',

      interestType: InterestsTypes.Industry,
      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Topic',
      interestType: InterestsTypes.Topic,

      options: [],
      classTypes: [InterestClassType.Identified],
    },
    {
      title: 'Person',
      interestType: InterestsTypes.Person,

      options: [],
      classTypes: [InterestClassType.Identified, InterestClassType.Recognized],
    },
    {
      title: 'Vehicle',
      interestType: InterestsTypes.Vehicle,

      options: [],
      classTypes: [InterestClassType.Identified, InterestClassType.Recognized],
    },
    {
      title: 'Functional Area',
      interestType: InterestsTypes.Functional_Area,

      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Communication',
      interestType: InterestsTypes.Communication,

      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Object',
      interestType: InterestsTypes.Object,

      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Incident',
      interestType: InterestsTypes.Incident,

      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Agent',
      interestType: InterestsTypes.Agent,
      options: [],
      classTypes: [InterestClassType.Recognized],
    },
    {
      title: 'Relation',
      interestType: InterestsTypes.Relation,
      options: [],
      classTypes: [InterestClassType.Identified],
    },
    {
      title: 'Transaction',
      interestType: InterestsTypes.Transaction,
      options: [],
      classTypes: [InterestClassType.Identified, InterestClassType.Recognized],
    },
  ],
  metadataFilters: [
    {
      title: 'nSearchPage.dataSourceType',
      valueName: 'sensorType',
      options: getEnumSelectOptions(SensorType, SENSOR_TYPE_WHITELIST()),
      inputType: 'select',
      order: 2,
    },
    {
      title: 'nSearchPage.dataSourceCategory',
      valueName: 'categoryType',
      options: getEnumSelectOptions(SensorCategoryType, SENSOR_CATEGORY_TYPE_WHITELIST()),
      inputType: 'select',
      order: 1,
    },
    {
      title: 'nSearchPage.dataSource',
      valueName: 'sensor',
      options: [],
      inputType: 'select',
      order: 3,
    },
    {
      title: 'nSearchPage.mediaType',
      valueName: 'mediaType',

      options: getEnumSelectOptions(MediaType, MEDIA_TYPE_WHITELIST()),
      inputType: 'select',
      order: 5,
    },

    {
      title: 'nSearchPage.date',
      valueName: 'date',
      inputType: 'date',
      order: 6,
    },
    // {
    //   title: 'nSearchPage.fusionDate',
    //   valueName: 'fusionDate',
    //   inputType: 'date',
    //   order: 7,
    // },
    // {
    //   title: 'Age',
    //   valueName: ['properties', 'ages'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    // {
    //   title: 'Collar',
    //   valueName: ['properties', 'collars'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    // {
    //   title: 'Brand',
    //   valueName: ['properties', 'brands'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    // {
    //   title: 'Color',
    //   valueName: ['properties', 'colors'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    // {
    //   title: 'Type',
    //   valueName: ['properties', 'unitType'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    // {
    //   title: 'Category',
    //   valueName: ['properties', 'unitCategory'],
    //   inputType: 'select',
    //   order: 4,
    //   hidden: true,
    //   options: [],
    // },
    {
      title: 'nSearchPage.coordinates',
      valueName: 'coordinates',
      inputType: 'coordinates',
      order: 7,
    },
  ],
});

export type LazyGetTriggerType<Data> = TypedLazyQueryTrigger<
  Data, // Response type
  LookupDataType | void, // Request parameters type
  any
>;

export type SelectedType = {
  interestType: InterestsTypes;
  classType: InterestClassType;
};

export type InterestFilterType = {
  interestFilters: {
    title: string;
    interestType: InterestsTypes;
    options: BaseOptionType[];
    route?: RoutesType;
    classTypes: InterestClassType[];
  }[];

  metadataFilters: {
    title: string;
    valueName: keyof MetadataCategories | [keyof MetadataCategories, any];
    options?: BaseOptionType[];
    inputType: 'select' | 'date' | 'coordinates';
    order: number;
    hidden?: boolean;
    // inputExtraValue?:
    //   | keyof MetadataCategories
    //   | [keyof MetadataCategories, any];
  }[];
};

export type MetadataCategories = {
  mediaType: MediaType[];
  sensorType: SensorType[];
  categoryType: SensorCategoryType[];
  date: { startTime?: number | null; endTime?: number | null };
  fusionDate: { startFusionDate?: number | null; endFusionDate?: number | null };
  sensor: string[];
  // properties: InterestPropertiesType;
  coordinates: { latitude: number | null; longitude: number | null }[];
};

// export const defaultProperties: InterestPropertiesType = {
//   ages: [],
//   brands: [],
//   colors: [],
//   domain_model: undefined,
//   sub_domain_model: undefined,
//   sub_sub_domain_model: undefined,
// };

export const getDefaultMetadataCategories = (
  interests?: {
    id: string;
    name: string;
    type: InterestsTypes;
    classType: InterestClassType;
    properties?: InterestPropertiesType;
  }[],
): MetadataCategories => {
  const foundSensor = interests?.find((int) => int.type === InterestsTypes.Sensor);
  return {
    sensor: foundSensor ? [foundSensor.id] : [],
    mediaType: [],
    sensorType: [],
    categoryType: [],
    date: { endTime: null, startTime: null },
    fusionDate: { endFusionDate: null, startFusionDate: null },
    // properties: interest?.properties ? { ...interest.properties } : defaultProperties,
    coordinates: [],
  };
};

export const convertNsearchToTopicTable = (nSearchResultData: NSearchResultType['blockDatas']) => {
  const topicTableData: MediaColumnDataType[] = [];

  for (let i = 0; i < nSearchResultData.length; i += 1) {
    const eachBlock = nSearchResultData[i];

    if (!eachBlock) {
      topicTableData.push({
        id: '',
        title: '',
        url: '',
        date: '',
        mediaType: '',
        violationType: '',
        status: '',
        fusionDate: '',
        isBlack: false,
      });
    } else {
      // TODO: ünlemleri daha sonra kaldır
      topicTableData.push({
        id: eachBlock.metadata.id,
        title: eachBlock.metadata.title || '',
        url: eachBlock.metadata.url || '',
        date: timeHelper.formatDate(eachBlock.metadata.startTime),
        fusionDate: timeHelper.formatDate(eachBlock.metadata.fusionDate),
        mediaType: getEnumKeyByValue(MediaType, eachBlock.metadata.dataType),
        violationType: eachBlock.metadata.violationType!,
        status: eachBlock.metadata.status!,
        isBlack: eachBlock.metadata.isBlack,
      });
    }
  }

  // nSearchResultData?.forEach((eachBlock) => {
  //   const categories: BlockResultType['interestList'] = [];

  //   eachBlock.interestList.forEach((interest) => {
  //     const foundCategory = categories.find((category) => category.type === interest.type);

  //     if (foundCategory) {
  //       foundCategory.interestId.push(...[...new Set(interest.interestId)]);
  //     } else {
  //       categories.push({
  //         ...interest,
  //         interestId: Array.from(new Set(interest.interestId)),
  //       });
  //     }
  //   });
  //   // TODO: ünlemleri daha sonra kaldır
  //   topicTableData.push({
  //     id: eachBlock.metadata.id,
  //     title: eachBlock.metadata.title || '',
  //     url: eachBlock.metadata.url || '',
  //     date: timeHelper.formatDate(eachBlock.metadata.startTime),
  //     mediaType: getEnumKeyByValue(MediaType, eachBlock.metadata.dataType),
  //     categories,
  //     violationType: eachBlock.metadata.violationType!,
  //     status: eachBlock.metadata.status!,
  //   });
  // });
  return topicTableData;
};

export const convertInterestListToCategories = (blockInterestList: BlockResultType['interestList']) => {
  const categories: BlockResultType['interestList'] = [];
  blockInterestList.forEach((interest) => {
    const foundCategory = categories.find((category) => category.type === interest.type);
    if (foundCategory) {
      foundCategory.interestId.push(...[...new Set(interest.interestId)]);
    } else {
      categories.push({
        ...interest,
        interestId: Array.from(new Set(interest.interestId)),
      });
    }
  });
  return categories;
};

export const getdefaultCategory = ({
  key,
  value,
}: {
  key: keyof NSearchType['categories'];
  value: string;
}): NSearchType['categories'] => {
  return {
    ...defaultCategories,
    [key]: [value],
  };
};

export const INTEREST_CATEGORIES: Partial<Record<InterestsTypes, keyof NSearchType['categories']>> = {
  [InterestsTypes.Enterprise]: 'company',
  [InterestsTypes.Location]: 'location',
  [InterestsTypes.Industry]: 'industry',
  [InterestsTypes.Topic]: 'topic',
  [InterestsTypes.Vehicle]: 'vehicle',
  [InterestsTypes.Person]: 'person',
  [InterestsTypes.Communication]: 'communication',
  [InterestsTypes.Functional_Area]: 'functionalArea',
  [InterestsTypes.Object]: 'object',
  [InterestsTypes.Incident]: 'incident',
  [InterestsTypes.Agent]: 'agent',
  [InterestsTypes.Relation]: 'relation',
  [InterestsTypes.Transaction]: 'transaction',
};

export const checkFilterDisabled = (categories: NSearchType['categories']): boolean => {
  let isEmpty: boolean = true;
  Object.entries(categories).forEach(([_, value]) => {
    if (value.length > 0) {
      isEmpty = false;
    }
  });
  return isEmpty;
};

export const convertTagsToCategories = (tags: NSearchTagType): NSearchType['categories'] => {
  const categories = cloneDeep(defaultCategories);
  tags?.forEach((tag) => {
    // @ts-ignore
    const field: CategoryObject[] = categories[INTEREST_CATEGORIES[tag.type]];
    if (field && !field.some((obj) => obj.id === tag.id)) field.push({ id: tag.id, properties: tag.props });
  });

  return categories;
};

export const getTagLabel = (name: string, type: InterestsTypes, classType: InterestClassType): string => {
  return `${getEnumKeyByValue(InterestsTypes, type)}, ${getEnumKeyByValue(InterestClassType, classType)}, ${name}`;
};

export const getSensorTypesFromCategories = (categories: SensorCategoryType[]) => {
  const sensorTypeOptions: SensorType[] = [];

  if (!categories.length) return getEnumSelectOptions(SensorType, SENSOR_TYPE_WHITELIST());
  categories.forEach((cat) => {
    const typeList = sensorCategoriesOfTypes[cat];
    typeList
      .filter((s) => SENSOR_TYPE_WHITELIST().includes(s))
      .forEach((sensor) => {
        sensorTypeOptions.push(sensor);
      });
  });

  return getEnumSelectOptions(SensorType, sensorTypeOptions);
};

export const getSensorListFromTypes = (selectedSensorTypes: SensorType[], sensorList: SensorIdentified[]) => {
  const sensorOptions: DefaultOptionType[] = [];

  sensorList.forEach((sensor) => {
    if (!selectedSensorTypes.length || selectedSensorTypes.includes(sensor?.type)) {
      sensorOptions.push({
        label: sensor.name,
        value: sensor.id,
        // title: sensor.type.toString(),
      });
    }
  });
  return sensorOptions;
};
export type NSearchLoggerQueryType = {
  interests?: {
    interest: string;
    interestType: string;
    interestClassType: string;
  }[];
  coordinates?: {
    lat: number | null;
    lng: number | null;
  }[];
  startTime?: number;
  endTime?: number;
  dataSource?: string[];
  dataSourceType?: SensorType[];
  dataSourceCategory?: SensorCategoryType[];
};

export interface SensorList {
  label: string;
  value: string;
}

// export const convertNSearchToFormData = () => {

// }

export const generateNSearchLogs = (
  query: NSearchType,
  metadataCategories: MetadataCategories,
  tagList: NSearchTagType,
  sensorList: SensorIdentified[],
) => {
  const selectedSensors: string[] = [];
  if (isDefined(sensorList) && sensorList.length > 0 && isDefined(query.sensors) && query.sensors.length > 0) {
    sensorList.forEach((sensor) => {
      if (query.sensors?.includes(sensor.id)) {
        selectedSensors.push(sensor.name);
      }
    });
  }

  const nSearchLoggerQuery = {
    ...(query.sensorCategoryTypes?.length && {
      dataSourceCategory: query.sensorCategoryTypes,
    }),
    ...(query.sensorTypes?.length && { dataSourceType: query.sensorTypes }),
    ...(query.sensors?.length && { dataSource: selectedSensors }),
    ...(query.endTime && { endTime: query.endTime }),
    ...(query.startTime && { startTime: query.startTime }),
    ...(query.coordinates?.length && {
      coordinates: [...metadataCategories.coordinates],
    }),
    ...(query.mediaTypes?.length && { mediaTypes: query.mediaTypes }),
    ...(tagList.length && {
      interests: tagList.map((tag) => tag.label),
    }),
  };
  return nSearchLoggerQuery;
};

export const getInterestPropsFromTag = (seedArr: SeedsResultType[keyof SeedsResultType], idArr: string[]) => {
  const result: { id: string; label: string }[] = [];
  idArr.forEach((id) => {
    seedArr.forEach((seed) => {
      if (seed.id === id) {
        result.push({ id, label: seed.name });
      }
    });
  });
  return result;
};

export const filterInterestCategories = (categories: NSearchResultType['blockDatas'][number]['interestList']) => {
  // Step 1: Create a map to store occurrences
  const countMap: Record<string, any> = {};

  categories.forEach((parent) => {
    parent.interestId.forEach((element) => {
      const { id, properties } = element;

      // If the id exists in countMap, we need to check for prop equality
      if (countMap[id]) {
        const existingElement = countMap[id].find((obj: any) => objectDeepCompare(obj.properties, properties));

        // If an element with the same props is found, increment its count
        if (existingElement) {
          existingElement.count += 1;
        } else {
          // If not found, add this new element with count 1
          countMap[id].push({ id, count: 1, properties });
        }
      } else {
        // If id does not exist in countMap, add it with count 1
        countMap[id] = [{ id, count: 1, properties }];
      }
    });
  });

  // Step 2: Create a new Parent array structure
  const deduplicatedParents: any = categories.map((parent) => ({
    type: parent.type,
    classEnum: parent.classEnum,
    interestId: parent.interestId.reduce<any[]>((acc, element) => {
      // Find the unique element from elementMap
      const uniqueElement = countMap[element.id].find((e: any) => objectDeepCompare(e.properties, element.properties));

      // Ensure no duplicates are added by checking if it's already in acc
      if (
        uniqueElement &&
        !acc.find((e) => e.id === uniqueElement.id && objectDeepCompare(e.properties, uniqueElement.properties))
      ) {
        acc.push(uniqueElement);
      }

      return acc;
    }, []),
  }));

  return deduplicatedParents;
};

export const getMostTrendingChartData = (
  chartData: ChartResultType['mostTrending'],
  interestList: InterestsWithNames[],
) => {
  const result: { name: string; date: string; value: number }[] = [];
  chartData.forEach((chart) => {
    interestList.forEach((row) => {
      row.interests.forEach((interest) => {
        if (interest.id === chart.id) {
          result.push({
            name: interest.value,
            date: moment().month(chart.date).format('MMMM').toString(),
            value: chart.value,
          });
        }
      });
    });
  });
  return result;
};

export const getMostPopularChartData = (
  chartData: ChartResultType['mostPopular'],
  interestList: InterestsWithNames[],
) => {
  const result: { name: string; value: number; type: string }[] = [];
  chartData.forEach((chart) => {
    interestList.forEach((row) => {
      row.interests.forEach((interest) => {
        if (interest.id === chart.id) {
          result.push({
            name: interest.value,
            type: getEnumKeyByValue(InterestsTypes, interest.type),
            value: chart.value,
          });
        }
      });
    });
  });
  return result;
};

export const convertNSearchReportDataToTableData = (
  reportList: NSearchReport[],
  { sensorList, interestList }: { sensorList: SensorIdentified[]; interestList: InterestsWithNames[] },
): NSearchReportColumnType[] => {
  const result: NSearchReportColumnType[] = [];

  reportList.forEach((report) => {
    // Get sensors
    const sensors: string[] = [];
    report?.sensors?.forEach((sensorId) => {
      const foundSensor = sensorList?.find((sensor) => sensor.id === sensorId);
      if (foundSensor) sensors.push(foundSensor.name);
    });

    // Get interests
    const interestCategoryList: NSearchResultType['blockDatas'][number]['interestList'] = [];

    Object.entries(INTEREST_CATEGORIES).forEach(([key, value]) => {
      Object.entries(report.categories).forEach(([categoryKey, categoryValue]) => {
        if (categoryKey === value) {
          interestList?.forEach((list) => {
            if (list.interestType === Number(key)) {
              list.interests.forEach((int) => {
                categoryValue.forEach((val) => {
                  if (val.id === int.id) {
                    const foundItem = interestCategoryList.find((icl) => icl.type === Number(key));
                    if (!foundItem)
                      interestCategoryList.push({
                        classEnum: int.classType,
                        type: int.type,
                        interestId: [{ id: int.id, properties: null }],
                      });
                    else foundItem.interestId.push({ id: int.id, properties: null });
                  }
                });
              });
            }
          });
        }
      });
    });

    result.push({
      id: report.id,
      interests: interestCategoryList,
      dataSource: sensors,
      endTime: report.endTime ? timeHelper.formatDate(report.endTime) : '',
      startTime: report.startTime ? timeHelper.formatDate(report.startTime) : '',
      mediaTypes: report.mediaTypes || [],
      period: report.period || '',
      hasReport: report.hasReport,
      lastCreatedDate: report.lastCreatedDate ? timeHelper.formatDate(report.lastCreatedDate) : '',
      name: report.name,
    });
  });
  return result;
};
